export default {
  init() {
  },
  finalize() {
    // Change full language name text to language code on mobile language switcher
    $('.mobile-lang-switcher .wpml-ls-item .wpml-ls-link').each(function() {
      const $langEl = $(this).find('.wpml-ls-native');
      const langCode = $langEl.attr('lang');

      if (langCode) {
        $langEl.html(langCode);
      }
    });

    // Toggle nav menu - burger stack
    $('.global-mobile-navbar-wrap .mobile-nav-toggle').on('click', function() {
      $('.nav-screen-level-one').removeClass('closed');
      $('.nav-screen-level-two').removeClass('open');
      
      $('.global-mobile-navbar-wrap').toggleClass('open');
      $('body').toggleClass('overflow-hidden');

      if ($('.global-mobile-navbar-wrap').hasClass('open')) {
        // Set height of the nav screen based on available screen real estate
        // const navTopY = $('.global-mobile-navbar-wrap .mobile-top-bar').offset().top;
        const navHeight = $('.global-mobile-navbar-wrap .mobile-top-bar').outerHeight();

        const allowedHeight = $(window).height() - navHeight;
        $('.global-mobile-navbar-wrap .mobile-nav-screen').css({ height: allowedHeight + 'px' });
      }
      
      $('.global-mobile-navbar-wrap .nav-screen-level-one-wrap').toggleClass('open');
    });

    // Click on first level item -> go to second level screen
    $('.global-mobile-navbar-wrap .nav-screen-level-one .nav-level-one-item.nav-item-has-children').on('click', function(e) {
      e.preventDefault();
      e.stopPropagation();

      const opensId = $(this).data('opens');
      const $opensEl = $(`.global-mobile-navbar-wrap .nav-screen-level-two .nav-level-two-section#${opensId}`);

      $('.global-mobile-navbar-wrap .nav-screen-level-two .nav-level-two-section').addClass('d-none');
      $('.global-mobile-navbar-wrap .nav-screen-level-one').addClass('closed');
      $('.global-mobile-navbar-wrap .nav-screen-level-two').addClass('open');
      $opensEl.removeClass('d-none');
    });

    // Click on return from second level -> go to first level
    $('.global-mobile-navbar-wrap .nav-screen-level-two .nav-screen-level-two-return').on('click', function() {
      $('.global-mobile-navbar-wrap .nav-screen-level-one').removeClass('closed');
      $('.global-mobile-navbar-wrap .nav-screen-level-two').removeClass('open');
    });

    // Open search.
    $('.mobile-link-item.mobile-search-btn').on('click', function(e) {
      e.stopPropagation();
      e.preventDefault();

      $('.global-search').addClass('show');
      $('.global-search .search-input').trigger('focus');
      $('body').addClass('overflow-hidden');
    });
  },
}


// WEBPACK FOOTER //
// ./scripts/partials/other/navigationMobile.js